import { requestGet } from '../utils/request';
import {
  shouldUseMockWithoutSeasonData,
  shouldUseMockWithCropWaterUseData,
} from '../utils/mocks';
import { MOSAIC_V3_IDS, MOSAIC_V3_MS_IDS } from '../constants/mapLayerIds';

const BASE_URL = '/api/mosaic/';

/**
 * Get Mosaic V3 layer events
 * @param {String} fieldId
 * @param {Number} userId
 * @return {Promise} Response
 */
export function requestMosaicV3Layers(fieldId, userId, webMicrosoftImageryFF) {
  const mosaicLayers = webMicrosoftImageryFF ? MOSAIC_V3_MS_IDS : MOSAIC_V3_IDS;
  const layers = encodeURIComponent(mosaicLayers.join(','));

  let mockFile;
  if (shouldUseMockWithoutSeasonData()) {
    mockFile = 'mosaic/v3/noData';
  } else if (shouldUseMockWithCropWaterUseData()) {
    mockFile = 'mosaic/v3/cropWaterData';
  } else {
    mockFile = 'mosaic/v3/default';
  }
  return requestGet(`${BASE_URL}v3/events/${fieldId}?layers=${layers}`, {
    mockFile,
    headers: {
      'x-user-id': userId,
    },
  });
}

/**
 * Get Mosaic V2 Soil SSURGO latest event
 * @param {String} fieldId
 * @param {Number} userId
 * @return {Promise} Response
 */
export function requestSoilSsurgoLatest(fieldId, userId) {
  const LAYER = 'soil';
  const REFERENCE = 'LATEST';
  const VERSION = 'v1';
  const TAG = 'ssurgo';
  const url = `${BASE_URL}v2/image/${fieldId}/${LAYER}/${REFERENCE}?version=${VERSION}&tag=${TAG}`;

  const mockFile = shouldUseMockWithoutSeasonData()
    ? 'mosaic/soilSsurgo/noData'
    : 'mosaic/soilSsurgo/default';

  return requestGet(url, {
    mockFile,
    headers: {
      'x-user-id': userId,
    },
  });
}

/**
 * Get Soil SSURGO geoJson file with specified zones
 * @param {String} imageId
 * @return {Promise} Response
 */
export function requestSoilSsurgoZones(imageId) {
  return requestGet(`${BASE_URL}v2/image/download/${imageId}`, {
    mockFile: shouldUseMockWithoutSeasonData()
      ? 'mosaic/soilSsurgo/noZones'
      : 'mosaic/soilSsurgo/zones',
    rootUrl: '',
  });
}

/**
 * Get Imported Shapefile Data
 * @param {action} action
 * @param {string} action.fieldId
 * @param {string} action.eventDate
 * @param {string} action.uuid
 * @return {Promise} Response
 */
export function requestImportedShapefileData(action) {
  const url =
    `${BASE_URL}v3/download/${action.fieldId}` +
    `/imported-map/${action.eventDate}/${action.uuid}`;

  return requestGet(url, {
    mockFile: 'mosaic/importedShapefile/default',
    removeCredentials: true,
    rootUrl: '',
    headers: {
      'x-user-id': action.userId,
    },
  });
}
